export default __webpack_public_path__ + "static/media/Tribal Necklace of Bloody Carnage.dba254c4.jpg";